import { Snackbar, SnackbarProps } from '@mui/material';
import { ReactElement } from 'react';

export function BaseSnackbar({ children, ...otherProps }: BaseSnackbarProps) {
  return <Snackbar {...otherProps}>{children}</Snackbar>;
}

interface BaseSnackbarProps extends Omit<SnackbarProps, 'children'> {
  children?: ReactElement<any, any> | undefined;
}
